import React, { useEffect, useRef, useState } from 'react';
import { useMessage } from './alert-context';
import "./style.css";
import { CheckCircle, Triangle } from 'react-feather';
import { CircleAlert, TriangleAlert } from 'lucide-react';
import ModalUserbaned from '../../ModalUserbaned';

const Alert: React.FC = () => {
    const { message, messageType, clearMessage, title, onCloseMessage, text } = useMessage();
    const [className, setClassName] = useState("");
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);
    const progressRef = useRef<HTMLDivElement | null>(null);

    const startTimer = () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
           if(!text?.trim().length) clearMessage();
        }, 5000);
        if (progressRef.current) {
            progressRef.current.style.animation = "none";
            void progressRef.current.offsetWidth; // força reflow
            progressRef.current.style.animation = "progress-left 5s linear forwards";
        }
    };

    useEffect(() => {
        if (message) startTimer();
        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, [message]);

    useEffect(() => {
        if (messageType === 'error') setClassName('alert-danger');
        if (messageType === 'success') setClassName('alert-success');
        if (messageType === 'warning') setClassName('alert-warning');
    }, [messageType]);

    if (!message) return null;

      // Converte URLs em links <a>
    const linkifiedMessage = message.replace(
        /(https?:\/\/[^\s]+)/g,
        '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
    );

    return (
        <>
        {text?.trim().length ? (
            <>
                {text}
                <ModalUserbaned
                    show={!!text?.trim().length}
                    onClose={onCloseMessage}
                    onConfirm={onCloseMessage} // Passa a senha aqui
                    title={`${linkifiedMessage ? linkifiedMessage : "Bloqueado"}`}
                    text={`Motivo: ${text}`}
                    coverMobile={true}
                    isLoading={false}
                    setPassword={() => {}}
                    idModal="remove-photo"
                />
            </>
        ): (
            <div
                id='alert-message'
                className={`alert alert-message alert-dismissible fade show ${className}`}
                role="alert"
                onMouseEnter={() => {
                    startTimer();
                    if (timeoutRef.current) clearTimeout(timeoutRef.current);
                    if (progressRef.current) {
                        progressRef.current.style.animationPlayState = "paused";
                    }
                }}
                onMouseLeave={() => {
                    startTimer(); // Reinicia tudo
                }}
            >
                <div style={{ display: "flex", gap: 5 }}>
                    <div style={{ display: "flex", alignItems: "center", marginRight: 5 }}>
                        {messageType == "success" ? <CheckCircle height={20} color='#659902'/> : null}
                        {messageType == "error" ? <CircleAlert height={20} color='#b1080a'/> : null}
                        {messageType == "warning" ? <TriangleAlert height={20} color='#fe8702'/> : null}
                    </div>
                    <div style={{ lineHeight: "23px" }}>
                        <span>{title ? <b>{title} <br /></b> : null}</span>
                        <span style={{ fontSize: 14 }} dangerouslySetInnerHTML={{ __html: linkifiedMessage }} />
                    </div>
                </div>

                <div className="progress-line-container">
                    <div ref={progressRef} className={`progress-bar ${className}`} />
                </div>

                <button style={{ color: "#fff!important" }} type="button" className="btn-close btn-close-notification" aria-label="Close" onClick={onCloseMessage}></button>
            </div>
            
            )}
        </>
    );
};

export default Alert;
